// Eskom PARCC — the Import / Bulk-update segmented switch.
//
// The two screens are separate ROUTES (so every existing deep link and the
// router's admin gate keep working), but they are one job: get a spreadsheet
// into the register. Lumen shows a single "Import & Bulk" item in the sidebar,
// and this is how you move between the two halves; Legacy keeps its two tabs
// AND gets this control, so neither theme is missing a way across.
import { NavLink, useInRouterContext } from 'react-router-dom';

export function ImportBulkTabs(): React.JSX.Element | null {
  // The page unit tests mount these screens bare, without a router. A navigation
  // affordance is not what those tests are about, so bow out rather than throw.
  if (!useInRouterContext()) return null;
  return (
    <div
      className="lm-segmented"
      role="tablist"
      aria-label="Import or bulk update"
      style={{ marginBottom: 16 }}
    >
      <NavLink to="/import" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
        Import population
      </NavLink>
      <NavLink to="/bulk-update" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
        Bulk update
      </NavLink>
    </div>
  );
}
